// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__V2aiA","load7":"Loader_load7__qfcw+"};